module.exports = __webpack_public_path__ + "static/media/tg.50f9070b.svg";